/**
 * Specifies the kind of priority given to customers.
 * tag: 2570
 * @readonly
 * @enum {number} (int)
 */
export enum CustomerPriority {
  NoPriority = 0,
  UnconditionalPriority = 1,
}
